<template>
  <div class="login-page">
    <div class="login-page-inner">
      <div class="login-card">
        <div class="login-brand">
          <img
            class="login-logo"
            src="@/assets/uestcp_logo.png"
            alt="电子科技大学出版社 · 数智出版云平台"
          />
        </div>
        <a-tabs class="login-tabs" default-active-key="1">
        <a-tab-pane key="1" tab="账号密码登陆">
          <div class="login-box">
            <a-form-model ref="ruleForm" :model="form" :rules="rules">
              <!-- <a-form-model-item prop="companyId">
                <a-select placeholder="请选择公司" v-model="form.companyId" style="width: 100%">
                  <a-select-option v-for="item in companyList" :key="item.id">
                    {{item.name}}
                  </a-select-option>
                </a-select>
              </a-form-model-item> -->
              <a-form-model-item prop="phoneNum">
                <a-input v-model="form.phoneNum" placeholder="用户名">
                </a-input>
              </a-form-model-item>
              <a-form-model-item prop="password">
                <a-input v-model="form.password" type="password" placeholder="登陆密码">
                </a-input>
              </a-form-model-item>
              <a-form-model-item>
                <a-button
                    :loading="loading"
                    style="width: 100%;"
                    type="primary"
                    @click="handleSubmit"
                >
                  登陆
                </a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
        </a-tab-pane>
        <!-- <a-tab-pane key="2" tab="钉钉扫码登陆" forceRender>
          <a-select placeholder="请选择公司" @change="ddSelectChnage" style="width: 100%">
            <a-select-option v-for="item in companyList" :key="item.id">
              {{item.name}}
            </a-select-option>
          </a-select>
          <div id="login_container">
            <span class="weCode">
            选择公司后生成登陆二维码
            </span>
          </div>
        </a-tab-pane> -->
      </a-tabs>
      </div>
    </div>
    <footer class="login-footer">
      <a href="https://ythzxfw.miit.gov.cn/index" target="_blank" rel="noopener noreferrer">蜀ICP备14017111号-5</a>
    </footer>
    
    <!-- 验证码验证弹窗 -->
    <a-modal
      v-model="verifyModalVisible"
      title="二次验证"
      :width="400"
      :maskClosable="false"
      :closable="true"
      @cancel="handleVerifyCancel"
    >
      <a-form-model ref="verifyForm" :model="verifyForm" :rules="verifyRules">
        <a-form-model-item prop="phone">
          <a-input 
            v-model="verifyForm.phone" 
            placeholder="请输入手机号"
            :maxLength="11"
          >
            <template slot="prefix">
              <a-icon type="mobile" />
            </template>
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="verifyCode">
          <a-input-group compact>
            <a-input
              v-model="verifyForm.verifyCode"
              placeholder="请输入短信验证码"
              :maxLength="6"
              style="width: 60%"
            >
              <template slot="prefix">
                <a-icon type="safety-certificate" />
              </template>
            </a-input>
            <a-button
              style="width: 40%"
              :disabled="countdown > 0"
              @click="handleSendVerifyCode"
            >
              {{ countdown > 0 ? `${countdown}秒后重发` : '发送验证码' }}
            </a-button>
          </a-input-group>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button @click="handleVerifyCancel">取消</a-button>
        <a-button type="primary" :loading="verifyLoading" @click="handleVerifySubmit">确认</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {cusData} from "@/utils/cusData";
import {setSession} from "@/utils/cusMethod";
import AccountApi from '@/api/src/account/api/AccountApi'
import TokenApi from '@/account_api/src/token/api/TokenApi'

const accountApi = new AccountApi();
const tokenApi = new TokenApi();
/** CMS 登录约定集团 companyId（与原 loginCompany 一致） */
const CMS_COMPANY_ID = 8

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      rules: {
        companyId: [
          {required: true, type: 'number', message: '请选择公司', trigger: 'change'}
        ],
        phoneNum: [
          {required: true, message: '请填写用户名', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请填写密码', trigger: 'blur'}
        ]
      },
      phoneNum: undefined,
      form: {
        companyId: undefined,
        phoneNum: '',
        password: '',
      },
      url: 'http://unipivot.natapp1.cc/login',
      companyId: '',
      appId: 'dingoakjkzjf5gmheneiy0',
      // 验证码弹窗相关
      verifyModalVisible: false,
      verifyLoading: false,
      verifyForm: {
        phone: '',
        verifyCode: ''
      },
      verifyRules: {
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        verifyCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {pattern: /^\d{6}$/, message: '请输入6位数字验证码', trigger: 'blur'}
        ]
      },
      countdown: 0,
      countdownTimer: null,
      /** TokenApi 二次验证链路预留；主登录已改为 AccountApi.loginByPwd，默认不会打开验证弹窗 */
      loginResp: null,
    }
  },


  computed: {
    ...mapGetters([
      'companyList'
    ]),
  },

  created() {

  },
  mounted() {
    // var _this = this;
    // let query = this.$route.query;
    // if(query.code && query.state){
    //   this.loading = true
    //   this.loginByDD({code: query.code,companyId: query.state}).then(res=>{
    //     setSession(cusData.USERINFO,res)
    //     setSession(cusData.companyId,this.companyId)
    //     this.loading = false
    //     this.$router.replace('/')
    //   })
    // }else {
    //   var handleMessage = function (event) {
    //     var origin = event.origin;
    //     console.log("event", event);
    //     if( origin == "https://login.dingtalk.com" ) { //判断是否来自ddLogin扫码事件。
    //       var loginTmpCode = event.data;
    //       var uri = 'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=' + ('dingoakjkzjf5gmheneiy0' || _this.appId) + '&response_type=code&scope=snsapi_login&state=' + _this.companyId +'&redirect_uri='+ _this.url +'&loginTmpCode=' + loginTmpCode
    //       window.location.replace(uri);
    //       //获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
    //     }
    //   };
    //   if (typeof window.addEventListener != 'undefined') {
    //     window.addEventListener('message', handleMessage, false);
    //   } else if (typeof window.attachEvent != 'undefined') {
    //     window.attachEvent('onmessage', handleMessage);
    //   }
    // }

  },
  methods: {
    ...mapActions(['login','loginByDD']),
    isCmsCompanyLogin(res) {
      if (res.company && res.company.id === CMS_COMPANY_ID) return true
      if (Array.isArray(res.companyList)) {
        return res.companyList.some((c) => c && c.id === CMS_COMPANY_ID)
      }
      return false
    },

    applyLoginSuccess(res) {
      localStorage.setItem('token', res.token)
      this.$store.commit('security/changeUser', { data: res })
      setSession(cusData.USERINFO, res)
      const cid =
        res.company && res.company.id != null ? res.company.id : CMS_COMPANY_ID
      setSession(cusData.companyId, cid)
    },

    handleSubmit() {
      this.$refs['ruleForm'].validate(async (valid) => {
        if (!valid) return false
        this.loading = true
        try {
          const res = await accountApi.loginByPwd({
            phoneNum: this.form.phoneNum,
            password: this.form.password,
          })
          console.log(res)

          if (res.type !== 1) {
            this.$message.error('非教师用户')
            return
          }
          // if (!this.isCmsCompanyLogin(res)) {
          //   this.$message.error('非集团用户')
          //   return
          // }

          this.applyLoginSuccess(res)
          this.$router.replace('/')
        } catch (e) {
          console.log(e)
          this.$message.error(e.message || '登录失败')
        } finally {
          this.loading = false
        }
      })
    },

    getDDCode(){
      let obj = window.DDLogin({
        id:"login_container",//这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
        goto: encodeURIComponent('https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=' + ('dingoakjkzjf5gmheneiy0' || this.appId) + '&response_type=code&scope=snsapi_login&state='+ this.companyId +'&redirect_uri=' + this.url), //请参考注释里的方式
        style: "border:none;background-color:#FFFFFF;",
        width : "280",
        height: "340"
      });
    },

    ddSelectChnage(e){
      let ddComList = this.companyList.find((item,key)=> item.id == e);
      this.companyId = ddComList.id;
      this.appId = ddComList.appId;
      this.$nextTick(()=>{
        this.getDDCode()
      })
    },

    // 发送验证码
    async handleSendVerifyCode() {
      // 验证手机号
      if (!this.verifyForm.phone) {
        this.$message.warning('请输入手机号')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.verifyForm.phone)) {
        this.$message.warning('请输入正确的手机号')
        return
      }

      try {
        let resp = await tokenApi.twoFactorSendPhoneMsg({phone: this.verifyForm.phone})
        console.log(resp)
        this.$message.success('验证码已发送')
        // 开始倒计时（不需要调用api，只是模拟）
        this.countdown = 60
        this.countdownTimer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            clearInterval(this.countdownTimer)
            this.countdownTimer = null
          }
        }, 1000)
        
      } catch(e) {
        console.log(e)
        this.$message.error(e.message)
      }
    },

    // 验证码验证提交
    handleVerifySubmit() {
      this.$refs['verifyForm'].validate(async (valid) => {
        if (valid) {
          this.verifyLoading = true
          try {
            // 这里不需要调用api，只是模拟验证
            // 实际应该调用验证接口验证验证码
            if (!this.verifyForm.verifyCode || this.verifyForm.verifyCode.length !== 6) {
              this.$message.error('请输入6位数字验证码')
              this.verifyLoading = false
              return
            }
            
            // 验证通过，继续登录流程
            if (this.loginResp) {
              const tokenResp = await tokenApi.getTokenByTwoFactor({
                app: 'CMS',
                phoneNum: this.verifyForm.phone,
                code: this.verifyForm.verifyCode,
              })

              const res = await accountApi.loginCompany({
                token: tokenResp.token,
                companyId: CMS_COMPANY_ID,
              })
              console.log(res)
              this.applyLoginSuccess(res)

              this.verifyModalVisible = false
              this.verifyLoading = false
              this.$router.replace('/')
            }
          } catch(e) {
            console.log(e)
            this.$message.error(e.message || '验证失败')
            this.verifyLoading = false
          }
        }
      })
    },

    // 取消验证
    handleVerifyCancel() {
      this.verifyModalVisible = false
      this.verifyForm.phone = ''
      this.verifyForm.verifyCode = ''
      this.loginResp = null
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
        this.countdown = 0
      }
    },
  },
  
  beforeDestroy() {
    // 清理倒计时定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
    }
  }
}
</script>

<style scoped lang="less">
.login-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #eef4fb;
  background-image: url('~@/assets/login_bg.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.login-page-inner {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px 48px;
  box-sizing: border-box;
}

.login-card {
  width: 100%;
  max-width: 420px;
  padding: 36px 40px 28px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(15, 45, 90, 0.08), 0 2px 8px rgba(15, 45, 90, 0.04);
  box-sizing: border-box;
}

.login-brand {
  text-align: center;
  padding-bottom: 24px;
  border-bottom: 1px solid #f0f0f0;
}

.login-logo {
  display: block;
  width: 100%;
  max-width: 340px;
  height: auto;
  margin: 0 auto;
  user-select: none;
  pointer-events: none;
}


.login-tabs {
  /deep/ .ant-tabs-bar {
    margin-bottom: 20px;
  }
}

.login-box {
  /deep/ .ant-form-item:last-child {
    margin-bottom: 0;
  }
}

.login-footer {
  flex-shrink: 0;
  text-align: center;
  padding: 12px 16px 20px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);

  a {
    color: rgba(0, 0, 0, 0.45);

    &:hover {
      color: #1890ff;
    }
  }
}

#login_container {
  margin: 0 auto;
  text-align: center;
  width: 300px;
  height: 400px;

  .weCode {
    display: inline-block;
    margin-top: 20px;
  }
}
</style>
